<template>
    <div class="createGuarantee fd-com-white-bg">
        <ac-title-bar title="申请保全" @back="back"></ac-title-bar>
        <div class="fd-com-scroll">
            <van-cell-group>
                <p style="color: #ee0a24; font-size: 14px;padding-left: 16px;padding-top: 10px">请先选择法院</p>
                <van-field
                        v-model="formData.cSqdyfymc"
                        required
                        clearable
                        readonly
                        label="选择法院"
                        right-icon="arrow"
                        placeholder="请选择申请法院"
                        @click="selectCourtBq"
                ></van-field>
                <van-field
                        v-model="formData.cBqlxText"
                        required
                        readonly
                        label="保全类型"
                        right-icon="arrow"
                        placeholder="请选择保全类型"
                        @click="handlerPicker('showBQLX', true)"
                ></van-field>
                <van-popup v-model="showBQLX" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsBqlx"
                            @cancel="handlerPicker('showBQLX', false)"
                            @confirm="onConfirmBQLX"
                    ></van-picker>
                </van-popup>
                <van-field
                        v-model="formData.cBqlbText"
                        required
                        readonly
                        label="保全类别"
                        right-icon="arrow"
                        placeholder="请选择保全类别"
                        @click="handlerPicker('showBQLB', true)"
                ></van-field>
                <div class="fd-com-warning-tip" v-if="!ahList.length">
                    系统未识别到您参与的诉讼案件，请您选择其它保全类型
                </div>
                <div class="fd-com-warning-tip" v-else>
                    如未在法院立案，请选择"诉前保全"；如已在法院立案，请选择"诉讼保全"。若选择错误，可能导致保全不成功
                </div>
                <van-popup v-model="showBQLB" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsBqlb"
                            :default-index="0"
                            @cancel="handlerPicker('showBQLB', false)"
                            @confirm="onConfirmBQLB"
                    ></van-picker>
                </van-popup>
                <div v-if="showSsbq">
                    <van-field
                            v-model="formData.nAjlxText"
                            required
                            readonly
                            label="案件类型"
                            right-icon="arrow"
                            placeholder="请选择案件类型"
                            @click="handlerPicker('showAJLX', true)"
                    ></van-field>
                    <van-popup v-model="showAJLX" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="columnsAjlx"
                                :default-index="0"
                                @cancel="handlerPicker('showAJLX', false)"
                                @confirm="onConfirmAJLX"
                        ></van-picker>
                    </van-popup>
                    <!-- <van-field
                            v-model="formData.cBqah"
                            required
                            class="amount-ipt"
                            label="案号"
                            placeholder="请输入2018年至今的案号"
                    ></van-field> -->
                    <section class="fd-com-section" v-if="formData.cBqlb === '2' && !ahList.length">
                        <div class="fd-com-title">
                            案号
                            <span class="fd-com-case">例：（2019）京01民初10号</span>
                        </div>
                        <van-field
                                v-model="formData.cAhNf"
                                required
                                readonly
                                label="年份"
                                right-icon="arrow"
                                placeholder="请选择年份"
                                @click="showAhNf = true"
                        ></van-field>
                        <van-popup v-model="showAhNf" position="bottom">
                            <van-picker
                                    show-toolbar
                                    :columns="timeList"
                                    :default-index="0"
                                    @cancel="handlerPicker('showAhNf', false)"
                                    @confirm="onConfirmAhNf"
                            ></van-picker>
                        </van-popup>
                        <van-field
                                v-model="formData.cAhFydz"
                                required
                                class="amount-ipt"
                                label="法院代字"
                                placeholder="请输入法院代字"
                        ></van-field>
                        <van-field
                                v-model="formData.cAhAjlxdz"
                                required
                                class="amount-ipt"
                                label="案件类型代字"
                                placeholder="请输入案件类型代字"
                        ></van-field>
                        <van-field
                                v-model="formData.cAhAjxh"
                                required
                                class="amount-ipt"
                                label="案件序号"
                                placeholder="请输入案件序号"
                        ></van-field>
                    </section>

                    <van-field
                        v-if="formData.cBqlb === '2' && ahList.length"
                        v-model="formData.cBqah"
                        required
                        readonly
                        label="诉讼案号"
                        right-icon="arrow"
                        placeholder="请选择案号"
                        @click="showSsah = true">
                    </van-field>
                    <van-popup v-model="showSsah" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="ahList"
                            :default-index="0"
                            value-key="cAh"
                            @cancel="handlerPicker('showSsah', false)"
                            @confirm="onConfirmSsah">
                        </van-picker>
                    </van-popup>
                </div>
                <van-field
                        v-show="formData.cBqlb == 2 && isSelctlx"
                        v-model="formData.cAy"
                        required
                        clearable
                        readonly
                        label="案由"
                        right-icon="arrow"
                        placeholder="请选择案由"
                        @click="selectAy"
                ></van-field>
                <van-field
                        v-show="formData.cBqlb == 2 && isSelctXZ"
                        v-model="formData.cAyName"
                        required
                        clearable
                        readonly
                        :label="ayLabel_1"
                        right-icon="arrow"
                        :placeholder="'请选择'+ayLabel_1"
                        @click="selectAyZT"
                ></van-field>
                <van-field
                        v-show="formData.cBqlb == 2 && isSelctXZ"
                        v-model="formData.cAyxzxwName"
                        required
                        clearable
                        readonly
                        :label="ayLabel_2"
                        right-icon="arrow"
                        :placeholder="'请选择'+ayLabel_2"
                        @click="selectAyXW"
                ></van-field>
                <van-field
                        v-show="formData.cBqlb == 2 && isSelctXZ && formData.cAhNf >= 2021"
                        v-model="formData.cXzaymc"
                        required
                        class="amount-ipt"
                        label="行政案由名称"
                        placeholder="请输入行政案由名称"
                ></van-field>
                <div v-if="showSqbq">
                    <van-field
                            v-model="formData.cFsqjText"
                            required
                            readonly
                            label="非诉期间"
                            right-icon="arrow"
                            placeholder="请选择非诉期间"
                            @click="handlerPicker('showFSQJ', true)"
                    ></van-field>
                    <van-popup v-model="showFSQJ" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="codeList_fsqj"
                                :default-index="0"
                                @cancel="handlerPicker('showFSQJ', false)"
                                @confirm="onConfirmFSQJ"
                        ></van-picker>
                    </van-popup>
                </div>
                <van-field
                        v-model="formData.nSqbqje"
                        required
                        class="amount-ipt"
                        label="申请保全金额(元)"
                        placeholder="请输入您要保全的数额"
                        maxlength="13"
                ></van-field>
                <!--                <van-number-keyboard-->
                <!--                        v-model="formData.nSqbqje"-->
                <!--                        :show="show"-->
                <!--                        extra-key="."-->
                <!--                        :maxlength="18"-->
                <!--                        @blur="show = false"-->
                <!--                />-->
                <van-field
                        v-model="formData.cDbqkText"
                        required
                        readonly
                        label="担保情况"
                        right-icon="arrow"
                        placeholder="请选择担保情况"
                        @click="handlerPicker('showDBQK', true)"
                ></van-field>


<!--                <van-popup v-if="formData.cBqlb == 2" v-model="showDBQK" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnDBQK"
                            :default-index="0"
                            @cancel="handlerPicker('showDBQK', false)"
                            @confirm="onConfirmDBQK"
                    ></van-picker>
                </van-popup>

                <van-popup v-if="formData.cBqlb == 1||formData.cBqlb == 4" v-model="showDBQK" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsqDBQK"
                            :default-index="0"
                            @cancel="handlerPicker('showDBQK', false)"
                            @confirm="onConfirmDBQK"
                    ></van-picker>
                </van-popup>-->

                <van-popup v-model="showDBQK" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columnDbqk2"
                        :default-index="0"
                        @cancel="handlerPicker('showDBQK', false)"
                        @confirm="onConfirmDBQK"
                    ></van-picker>
                </van-popup>

                <van-field
                        v-if="formData.cDbqk == 3"
                        v-model="formData.nWdbyyText"
                        label="无需担保原因"
                        placeholder="请选择无需担保原因"
                        required
                        readonly
                        right-icon="arrow"
                        @click="handlerPicker('showWXDB', true)"
                ></van-field>
                <van-popup v-model="showWXDB" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="codeList_601000"
                            :default-index="0"
                            @cancel="handlerPicker('showWXDB', false)"
                            @confirm="onConfirmWXDB"
                    ></van-picker>
                </van-popup>
                <van-field
                        v-model="formData.cTjrlxText"
                        required
                        readonly
                        label="提交人身份"
                        right-icon="arrow"
                        placeholder="请选择提交人身份"
                        @click="showTJRLX = true"
                ></van-field>
                <van-popup v-model="showTJRLX" position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnTJRLX"
                            :default-index="0"
                            @cancel="handlerPicker('showTJRLX', false)"
                            @confirm="onConfirmTJRLX"
                    ></van-picker>
                </van-popup>
            </van-cell-group>
            <div
                    v-if="this.formData.nSqbqje"
                    class="advice-amount">
                <span>建议保全费：<span>{{RMB}}</span>元</span>
            </div>
        </div>
        <div class="fd-com-btn-container">
            <!--担保情况为无担保时不允许申请保全-->
            <van-button
                type="info"
                round
                :disabled="isCanCreate"
                @click="saveSqbqInfo">
                申请保全
            </van-button>
        </div>
    </div>
</template>

<script>
    import {Notify} from 'vant'
    // 标题栏
    import acTitleBar from '@/components/app/title-bar/index.vue';
    import {mapGetters} from 'vuex'
    import {
        columns,
        columnsBqlx,
        columnsAjlx,
        columnsFsqj,
        columnsTJR,
        columnsDbqk,
        columnsWxdb,
        columnsAhnf
    } from '../../utils/option';
    import validate from '@/utils/validator/validator';
    import {
        xzfyRule,
        bqlbRule,
        bqlxRule,
        fsqjRule,
        SqbqjeRule,
        tjrsfRule,
        dbqkRule,
        ajlxRule,
        AhRule,
        AyRule,
        wdbyy,
        ahNfRule,
        FydzRule,
        AjlxdzRule,
        AjxhRule,
        cAyNameRule,
        cAyxzxwNameRule,
        cXzaymcRule
    } from '@/utils/validator/rules';
    import {
        typeBqlb,
        typeBqlx,
        typeFsccFsqj,
        typeTjrlx,
        typeDbqk,
        typeAjlx,
    }
        from '../../filters/index';

    export default {
        data() {
            return {
                // 对接在线服务网新增——案号下拉列表
                ahList: [],
                // 对接在线服务网新增——是否显示诉讼案号下拉列表
                showSsah: false,
                formData: {
                    // 对接在线服务网新增——案号代码
                    cAhdm: '',
                    nSqfy: '',
                    cSqdyfymc: '',//申请第一法院名称
                    cBqlb: null,//保全类别
                    cBqlbText: '',
                    cBqlx: null,//保全类型
                    cBqlxText: '',
                    cFsqj: 1,//非诉期间
                    cFsqjText: '未起诉或提起仲裁前',
                    nSqbqje: '',//申请保全金额
                    nAjlx: '',//案件类型
                    nAjlxText: '',
                    cDbqk: '',//担保情况
                    cDbqkText: '',
                    cTjrlx: 1,//提交人身份
                    cTjrlxText: '申请人',
                    cBqah: '',//保全案号

                    cAhNf: '',//案号年份
                    cAhFydz: '',//案号法院代字
                    cAhAjlxdz: '',//案号案件类型代字
                    cAhAjxh: '',//案号序号

                    cAy: '',//案由
                    cAycode: '',
                    nSqbqdcsfy: '',
                    nWdbyy: '',
                    nWdbyyText: '',
                    cAyxzxw: '',//案由代码值
                    cAyName: '',//案由主体类型
                    cAyxzxwName: '',//案由行为种类
                    cXzaymc:''
                },
                postData: {
                    nSqfy: '',//申请法院
                    cSqdyfymc: '',//申请第一法院名称
                    cBqlb: '',//保全类别
                    cBqlx: '',//保全类型
                    cFsqj: '',//非诉期间
                    nSqbqje: '',//申请保全金额
                    nAjlx: '',//案件类型
                    cDbqk: '',//担保情况
                    cTjrlx: '',//提交人身份
                    cBqah: '',//保全案号

                    cAhNf: '',//案号年份
                    cAhFydz: '',//案号法院代字
                    cAhAjlxdz: '',//案号案件类型代字
                    cAhAjxh: '',//案号序号

                    cAy: '',//保全案由
                    cAycode: '',
                    nWdbyy: '',
                    nSqbqdcsfy: '',
                    cAyxzxw: '',//案由代码值
                    cAyName: '',//案由主体类型
                    cAyxzxwName: '',//案由行为种类
                    cXzaymc:''
                },
                showAhNf: false, //案号年份
                timeList:[], //年份列表
                columnsAhnf: columnsAhnf,
                isSelctlx: false,//控制案由的显示隐藏
                isSelctXZ: false,//控制案由（行政）的显示隐藏
                showPickerAY: false, //案由
                showBQLB: false,
                columnBQLB: columns,
                showBQLX: false,
                columnBQLX: columnsBqlx,
                showAJLX: false,
                columnAJLX: columnsAjlx,
                showTJRLX: false,
                columnTJRLX: columnsTJR,
                columnsqDBQK: [{keyId: 1, text: "有担保"}],
                columnsWxdb: columnsWxdb,
                showDBQK: false,
                columnDBQK: columnsDbqk,
                showFSQJ: false,
                columnFSQJ: columnsFsqj,
                showSqbq: false,
                showSsbq: false,
                show: false,
                showWXDB: false,
                value: '',
                history: [],
                isFirstEnter: null,
                powerKeys_cBqlb: '',
                powerKeys_cBqlx: '',
                powerKeys_cFysx: '',

                permission_bq:{},

                ayLabel_1:'',
                ayLabel_2:'',
            }
        },
        components: {
            acTitleBar
        },
        watch: {
            'formData.cBqlx'(value){
                if(value&&this.permission_bq.lxtolb[value]){
                    this.powerKeys_cBqlb=this.permission_bq.lxtolb[value].sort().join(',');
                }
            },
            'formData.cBqlb'(value){
                if(value&&this.permission_bq.lbtolx[value]){
                    this.powerKeys_cBqlx=this.permission_bq.lbtolx[value].sort().join(',')
                }
            },
            'formData.cSqdyfymc': function () {
                if(this.powerKeys_cBqlb&&this.powerKeys_cBqlb.length>0){
                    let cBqlb = this.powerKeys_cBqlb.split(',')[0]
                    this.onConfirmBQLB({text: typeBqlb(cBqlb), keyId: cBqlb})
                    let cBqlx = this.powerKeys_cBqlx.split(',')[0]
                    console.log('formData.cSqdyfymc====', typeBqlx(cBqlx), cBqlx)
                    this.onConfirmBQLX({text: typeBqlx(cBqlx), keyId: cBqlx})
                }
            },
            'formData.cAhNf'(value, oldValue) {
                console.log('----更改年份 watch 111','varlue:'+value,'oldValue:'+oldValue);
                var nfKey_new = Number(value) >= 2021 ? 2 : 1;
                var nfKey_old = Number(oldValue) >= 2021 ? 2 : 1;
                if (!oldValue||(value && oldValue && (nfKey_new !== nfKey_old))) {
                    this.initAyLabel();
                    this.initAyValue();
                }
            }
        },
        created() {
            console.log('--created 000');
            this.sendFy()
            this.sendAy()
            this.getPageData()
            this.initCodeType()
            // 对接在线服务网新增——获取案号下拉列表数据
            this.getAhList();
        },
        activated() {
            console.log('--activated 000');
            this.sendFy()
            this.sendAy()
            console.log(this.formData.cBqlx)
            console.log( this.formData.cBqlxText)
            console.log( this.formData.cBqlb)
        },
        methods: {

            /**
             * @function
             * @description 对接在线服务网新增——获取案号下拉列表数据
             * @return {undefined} 无返回值
             */
            getAhList() {
                const params = {
                    zxfwToken: localStorage.getItem('zxfwtoken')
                };
                this.$axios.get('ssbq/api/bqyzw/bqsq/ahList', params).then((res) => {
                    if (res.code === 200) {
                        this.ahList = res.data;
                    } else {
                        console.log('案号下拉列表获取失败');
                    }
                });
            },

            /**
             * @function
             * @description 对接在线服务网新增——切换诉讼案号
             * @return {undefined} 无返回值
             */
            onConfirmSsah(item) {
                this.formData.cAhdm = item.cAhdm;
                this.formData.cBqah = item.cAh;
                // 案号年份，从中文案号里面截取出年份，不然加选案号列表的接口后提交接口会报500
                this.formData.cAhNf = this.formData.cBqah.slice(1, 5);
                console.log('案号代码：', this.formData.cAhdm);
                console.log('诉讼案号：', this.formData.cBqah);
                console.log('案号年份：', this.formData.cAhNf);
                this.showSsah = false;
            },

            back() {
                // 返回首页
                this.$router.push("/home/index");
            },
            /* 操作选择弹层 */
            handlerPicker(name, type) {
                /* 选择保全类型和保全类别需要先提示选择法院 */
                if ((name === 'showBQLX' || name === 'showBQLB') && !this.formData.cSqdyfymc) {
                    Notify({type: 'danger', message: '请先选择法院'})
                    return
                }
                this[name] = type
            },
            initCodeType() {
                this.$store.dispatch('GetCodeType', 118000)
                this.$store.dispatch('GetCodeType', 121000)
                this.$store.dispatch('GetCodeType', 301000)
                this.$store.dispatch('GetCodeType', 301110)
                this.$store.dispatch('GetCodeType', 301160)
                this.$store.dispatch('GetCodeType', 301210)
                this.$store.dispatch('GetCodeType', 301510)
                this.$store.dispatch('GetCodeType', 304000)
                this.$store.dispatch('GetCodeType', 601000)

                this.$axios.get('ssbq/api/nfs').then(res => {
                    console.log('--res 000', res);
                    let yearList2 = res.data.map(item => Object({text: Number(item), keyId: Number(item)}));
                    console.log('--yearList2 000', yearList2);
                    this.timeList=yearList2;
                    // return yearList2
                })

            },
            /* 初始化权限字 */
            initPowerKeys() {
                let cBqlb = this.powerKeys_cBqlb
                let cBqlx = this.powerKeys_cBqlx

                var permission_bq = sessionStorage.getItem('permission_bq') || ''
                permission_bq&&(permission_bq=JSON.parse(permission_bq));
                this.permission_bq=permission_bq;

                // this.powerKeys_cBqlb = sessionStorage.getItem('powerKeys_cBqlb') || ''
                this.powerKeys_cBqlx = sessionStorage.getItem('powerKeys_cBqlx') || ''
                this.powerKeys_cFysx = sessionStorage.getItem('powerKeys_cFysx') || ''

                /* 初始化保全类型和类别 */

                if (this.powerKeys_cBqlx && cBqlx !== this.powerKeys_cBqlx) {
                    let cBqlx = this.powerKeys_cBqlx.split(',')[0]
                    this.powerKeys_cBqlb=permission_bq.lxtolb[cBqlx].sort().join(',');
                    console.log('initPowerKeys=====', typeBqlx(cBqlx), cBqlx)
                    this.onConfirmBQLX({text: typeBqlx(cBqlx), keyId: cBqlx})
                }

                if (this.powerKeys_cBqlb && cBqlb !== this.powerKeys_cBqlb) {
                    // let cBqlb = this.powerKeys_cBqlb.split(',')[0]
                    let cBqlb = this.powerKeys_cBqlb.split(',')[0]
                    this.onConfirmBQLB({text: typeBqlb(cBqlb), keyId: cBqlb})
                }

                if(!this.powerKeys_cBqlx){
                    this.formData.cBqlbText = '';
                    this.formData.cBqlb = '';
                    this.powerKeys_cBqlb=[];
                }
            },
            //选择案号年份
            onConfirmAhNf(item) {
                console.log('--onConfirmAhNf 000',item);
                this.formData.cAhNf = item.text;
                this.showAhNf = false
            },
            //选择案由
            selectAy() {
                sessionStorage.removeItem("Aysz")
                sessionStorage.setItem("cAhNf",this.formData.cAhNf)
                this.$router.push({
                    path: "/selectAy",
                });
            },
            //选择案由行为
            selectAyXW() {
                //this.formData.cAyxzxw = 2;
                sessionStorage.setItem("cAhNf",this.formData.cAhNf)
                sessionStorage.setItem("Aysz", this.formData.cAyxzxw)
                this.$router.push({
                    path: "/selectAyXW",
                });
            },
            //选择案由主体
            selectAyZT() {
                //this.formData.cAyxzxw = 1;
                sessionStorage.setItem("cAhNf",this.formData.cAhNf)
                sessionStorage.setItem("Aysz", this.formData.cAyxzxw)
                this.$router.push({
                    path: "/selectAy",
                });
            },
            //获取案由
            sendAy() {
                let selectay = sessionStorage.getItem('selectay');
                let selectayId = sessionStorage.getItem('selectayId')
                if (selectayId) {
                    this.formData.cAycode = selectayId;
                }
                if (selectay) {
                    this.formData.cAy = JSON.parse(selectay)
                    this.formData.cAyName = JSON.parse(selectay)
                }
                //获取行为案由
                let Ayxw = sessionStorage.getItem('Ayxw')

                let AyxwId = sessionStorage.getItem('AyxwId');
                if (!Ayxw) {
                    return
                }
                if (!AyxwId) {
                    return
                }

                let AyxwIdstr = JSON.parse(AyxwId).join(',');
                this.formData.cAyxzxw = AyxwIdstr

                let AyxwStr = JSON.parse(Ayxw).join(',')
                this.formData.cAyxzxwName = AyxwStr
                this.formData.cXzaymc = AyxwStr
            },
            //担保已出函快速申请保全
            getBqJbxx() {
                return new Promise((resolve) => {
                    let bqid = JSON.parse(sessionStorage.getItem("fastDbid"));
                    this.bqid = bqid
                    this.$axios.get('ssbq/api/ssdb/dbjbxx?dbid=' + bqid).then(res => {
                        // 获取案号案由案件类型, 提交时需要一并提交
                        this.formData.nSqfy = res.data.cFyid
                        this.formData.cSqdyfymc = res.data.cFymc
                        this.formData.cBqlb = res.data.cBqlb;
                        this.formData.nAjlx = res.data.nAjlx;
                        columnsAjlx.map((item) => {
                            if (item.keyId == this.formData.nAjlx) {
                                this.formData.nAjlxText = item.text
                            }
                        })
                        if (res.data.cBqlb == 2) {
                            this.showSqbq = false;
                            this.showSsbq = true;
                        }
                        this.formData.cBqlbText = typeBqlb(res.data.cBqlb)
                        this.formData.cBqlx = "1"
                        this.formData.cBqlxText = typeBqlx("1")
                        this.formData.cFsqj = res.data.cFsqj
                        this.formData.cFsqjText = typeFsccFsqj(res.data.cFsqj)
                        this.formData.nSqbqje = res.data.nSqbqje
                        this.formData.cTjrlx = res.data.cTjrlx
                        this.formData.cBqah = res.data.cAh
                        this.formData.cAy = res.data.cAy
                        this.formData.cDbqk = res.data.cDbqk || '1'
                        columnsDbqk.map((item) => {
                            if (item.keyId == this.formData.cDbqk) {
                                this.formData.cDbqkText = item.text
                            }
                        })
                        this.formData.cTjrlxText = typeTjrlx(res.data.cTjrlx)
                        resolve()
                    })
                })
            },
            //刷新页面或者从别的页面进入，提取this.history的值
            getPageData() {
                this.history = JSON.parse(localStorage.getItem('this.history'))
            },
            sendFy() {
                let fcheckedFy = sessionStorage.getItem('fcheckedFy');
                if (fcheckedFy) {
                    let fyInfo = JSON.parse(fcheckedFy);
                    if (fyInfo.checkedFy !== this.formData.cSqdyfymc) {
                        this.formData.cBqlx = ''
                        this.formData.cBqlxText = ''
                        this.formData.cBqlb = ''
                        this.formData.cBqlbText = ''
                    }
                    this.formData.cSqdyfymc = fyInfo.checkedFy
                    this.formData.nSqfy = fyInfo.cId
                }
            },
            selectCourtBq() {
                this.$router.push({
                    path: "/selectBqCourt",
                });
            },
            onConfirmBQLB(item) {
                this.formData.cBqlbText = item.text;
                this.formData.cBqlb = item.keyId;
                this.showBQLB = false;
                if (item.keyId == "1"||item.keyId == "4") {
                    this.showSqbq = true;
                    this.showSsbq = false;
                    this.formData.cDbqkText = "";
                    this.formData.cDbqk = "";
                    this.postData.cDbqk = "";
                } else if (item.keyId == "2") {
                    this.showSqbq = false;
                    this.showSsbq = true;
                }
            },
            //无需担保原因
            onConfirmWXDB(item) {
                this.formData.nWdbyy = item.keyId;
                this.formData.nWdbyyText = item.text;
                this.showWXDB = false
            },
            onConfirmBQLX(item) {
                console.log('onConfirmBQLX(item)====', this.formData.cBqlxText)
                console.log('onConfirmBQLX(item)====', this.formData.cBqlx)
                // let cBqlxSessionStorage = sessionStorage.getItem('powerKeys_cBqlx')
                this.formData.cBqlxText = item.text;
                this.formData.cBqlx = item.keyId;
                sessionStorage.setItem('powerKeys_cBqlx', this.formData.cBqlx)
                // cBqlxSessionStorage = this.formData.cBqlx
                console.log('onConfirmBQLX(item)2====', this.formData.cBqlxText)
                console.log('onConfirmBQLX(item)2====', this.formData.cBqlx)
                this.showBQLX = false
            },
            initAyLabel(){
                let {cAhNf, nAjlx} = this.formData;
                var key = (Number(cAhNf) >= 2021) ? 2021 : 2020;
                if (key === 2020) {
                    this.ayLabel_1 = Number(nAjlx) === 6 ? '案由(主体类型)' : '案由';
                    this.ayLabel_2 = '案由(行为种类)';
                } else {
                    this.ayLabel_1 = Number(nAjlx) === 6 ? '行政主体类型' : '案由';
                    this.ayLabel_2 = '行政案由';
                }
            },
            initAyValue(){
                /* 重置案由 */
                this.formData.cAy = ''
                this.formData.cAyxzxw = ''
                this.formData.cAyName = ''
                this.formData.cAyxzxwName = ''
                this.formData.cXzaymc = ''
                sessionStorage.setItem('selectay', '')
                sessionStorage.setItem('selectayId', '')
                sessionStorage.removeItem('Ayxw')
                sessionStorage.removeItem('AyxwId')
            },
            onConfirmAJLX(item) {
                console.log('--onConfirmAJLX 000',item);
                if (item.keyId == 1 || item.keyId == 2) {
                    this.isSelctlx = true
                } else {
                    this.isSelctlx = false
                }
                if (item.keyId == 6) {
                    this.isSelctXZ = true;
                } else {
                    this.isSelctXZ = false;
                }

                this.formData.nAjlxText = item.text;
                this.formData.nAjlx = item.keyId;
                sessionStorage.setItem("nAjlx", item.keyId)
                this.showAJLX = false

                this.initAyLabel();
                this.initAyValue();
            },
            onConfirmTJRLX(item) {
                this.formData.cTjrlxText = item.text;
                this.formData.cTjrlx = item.keyId;
                this.showTJRLX = false
            },
            onConfirmDBQK(item) {

                if(this.formData.cBqlb!=='4'&&(item.keyId===2&&this.formData.cBqlx==='1')){
                    this.$notify("请您先办理担保");
                }

                /*if (item.keyId == 2) {
                    // 无担保提示办理担保
                    this.$notify("请您先办理担保");
                }*/

                window.sessionStorage.setItem("dbqk", item.keyId)
                this.formData.cDbqkText = item.text;
                this.formData.cDbqk = item.keyId;
                this.showDBQK = false
            },
            onConfirmFSQJ(item) {
                this.formData.cFsqjText = item.text;
                this.formData.cFsqj = item.keyId;
                this.showFSQJ = false
            },
            saveSqbqInfo() {
                const validated = this.validateFormData();
                validated.then(() => {
                    // 如果案号是下拉选择的，则从数组里取中文名；是手填时，拼接案号名称
                    if (this.formData.cBqlb === '2' &&　this.ahList.length) {
                        const index = this.ahList.findIndex(item => item.cAh === this.formData.cBqah);
                        this.formData.cAhdm = this.ahList[index].cAhdm;
                    } else {
                        this.formData.cBqah = `（${this.formData.cAhNf}）${this.formData.cAhFydz}${this.formData.cAhAjlxdz}${this.formData.cAhAjxh}号`;
                    }
                    // if(this.formData.cSqdyfymc.includes("上海")){
                    //   this.$axios.post('account/api/shbq/ssoMobileUrl',this.formData)
                    //       .then(res => {
                    //         let data = res.data;
                    //         if(''==data){
                    //           console.log("看看返回的data====",res.message);
                    //         }else{
                    //           window.location.href=data;
                    //         }
                    //         console.log("看看返回的data====",data)
                    //
                    //       }).catch(function (error) {
                    //            console.log(error)
                    //   });
                    // }else{
                        // 当前页面嵌入在了线服务网，并且选择了诉讼保全时，要调接口获取案号代码
                        console.log('_____zxfwtoken：', localStorage.getItem('zxfwtoken'));
                        console.log('_____cBqlb：', this.formData.cBqlb);
                        if (localStorage.getItem('zxfwtoken') && this.formData.cBqlb === '2') {
                            this.postData.cAhdm = this.formData.cAhdm;
                            this.submitSqbqInfo();
                        } else {
                            this.postData.cAhdm = '';
                            this.submitSqbqInfo();
                        }
                    //}
                });
            },
            submitSqbqInfo: function () {
                this.getData()
                return new Promise((resolve, reject) => {
                    let dbid = JSON.parse(sessionStorage.getItem("fastDbid"));
                    if (dbid == null || dbid == '') {
                        dbid = ''
                    }
                    // 如果案号是下拉选择的，则从数组里取中文名；是手填时，拼接案号名称
                    if (this.postData.cBqlb === '2' &&　this.ahList.length) {
                        const index = this.ahList.findIndex(item => item.cAh === this.postData.cBqah);
                        this.postData.cAhdm = this.ahList[index].cAhdm;
                    } else {
                        this.postData.cBqah = `（${this.postData.cAhNf}）${this.postData.cAhFydz + this.postData.cAhAjlxdz + this.postData.cAhAjxh}号`;
                    }

                    let selectayId = sessionStorage.getItem('selectayId')
                    let AyxwId = sessionStorage.getItem('AyxwId')
                    if (selectayId) {
                        this.postData.cAycode = JSON.parse(sessionStorage.getItem('selectayId'))
                        this.postData.cAyName = JSON.parse(sessionStorage.getItem('selectay'))
                    }
                    if (AyxwId) {
                        this.postData.cAyxzxw = JSON.parse(AyxwId).join(',')+',';
                        this.postData.cAyxzxwName = JSON.parse(sessionStorage.getItem('Ayxw')).join(',')
                    }
                    if (this.postData.cBqlb === '1') {
                        this.postData.cAy = ''
                        this.postData.cAyName = ''
                        this.postData.cAycode = ''
                        this.postData.cAyxzxw = ''
                        this.postData.cAyxzxwName = ''
                        this.postData.cXzaymc = ''
                        this.postData.nAjlx = ''
                        this.postData.cBqah = ''
                        this.postData.cAhAjlxdz = ''
                        this.postData.cAhAjxh = ''
                        this.postData.cAhFydz = ''
                        this.postData.cAhNf = ''
                    }

                    console.log('--this.postData',this.postData);
                    //return false;
                    this.$axios.post('ssbq/api/bqsq?ly=2&dbid=' + dbid, this.postData).then(res => {
                        sessionStorage.setItem("currentBqid", JSON.stringify(res.data));
                        this.$router.push({
                            path: '/preservationInfo',
                        })
                        sessionStorage.removeItem("fastDbid")
                        sessionStorage.removeItem('selectay');
                        sessionStorage.removeItem('Ayxw');
                        sessionStorage.removeItem('AyxwId');
                        resolve()
                    }).catch((err) => {
                        reject(err)
                    })
                })
            },
            getData() {
                this.postData.nSqfy = this.formData.nSqfy;
                this.postData.cSqdyfymc = this.formData.cSqdyfymc;
                this.postData.cBqlb = this.formData.cBqlb;
                // this.postData.cBqlx = this.formData.cBqlx;
                this.postData.cBqlx = this.formData.cBqlx;
                this.postData.cFsqj = this.formData.cFsqj;
                this.postData.nSqbqje = Number(this.formData.nSqbqje);
                this.postData.nAjlx = this.formData.nAjlx;
                this.postData.cDbqk = this.formData.cDbqk;
                this.postData.cTjrlx = this.formData.cTjrlx;
                this.postData.cAhNf = this.formData.cAhNf;
                this.postData.cAhFydz = this.formData.cAhFydz;
                this.postData.cAhAjlxdz = this.formData.cAhAjlxdz;
                this.postData.cAhAjxh = this.formData.cAhAjxh;
                this.postData.cBqah = this.formData.cBqah;
                this.postData.cAy = this.formData.cAy;
                this.postData.nWdbyy = this.formData.nWdbyy;
                this.postData.cAycode = this.formData.cAycode;
                this.postData.cAyxzxw = this.formData.cAyxzxw;
                this.postData.cXzaymc = this.formData.cXzaymc;
            },
            validateFormData: function () {
                let descriptor = {
                    nSqfy: xzfyRule,
                    cBqlx: bqlxRule,
                    cBqlb: bqlbRule,
                };
                if (this.formData.cBqlb == 2) {
                    // 诉讼保全
                    descriptor.nAjlx = ajlxRule;
                    // descriptor.cBqah = new AhRule(true);
                    descriptor.cAhNf = ahNfRule;
                    // 当案号不用下拉选择时，才校验手填案号的字段项
                    if (!this.ahList.length) {
                        descriptor.cAhFydz = new FydzRule(true,this.formData.nSqfy);
                        descriptor.cAhAjlxdz = new AjlxdzRule(true);
                        descriptor.cAhAjxh = new AjxhRule(true);
                    }
                    if(this.isSelctlx){
                        descriptor.cAy = AyRule(true);
                    }else{
                        descriptor.cAyName = cAyNameRule(true,this.ayLabel_1);
                        descriptor.cAyxzxwName = cAyxzxwNameRule(true,this.ayLabel_2);
                        if(this.formData.cAhNf>=2021){
                            descriptor.cXzaymc=cXzaymcRule(true)
                        }
                    }
                } else {
                    // 诉前保全
                    descriptor.cFsqj = fsqjRule;
                }
                if (this.formData.cBqlb == 2 && this.formData.cDbqk == 3) {
                    descriptor.nWdbyy = wdbyy;
                }
                descriptor.nSqbqje = new SqbqjeRule(true);
                descriptor.cDbqk = dbqkRule;
                descriptor.cTjrlx = tjrsfRule;
                const validated = validate(descriptor, this.formData);
                return validated;
            },
        },
        computed: {
            ...mapGetters(['codeList_118000', 'codeList_121000', 'codeList_601000', 'codeList_301000', 'codeList_304000', 'codeList_301110','codeList_301160', 'codeList_301210', 'codeList_301510']),
            columnDbqk2(){
                let [v1,v2,v3] = [
                    {keyId: 1, text: "有担保"},
                    {keyId: 3, text: "无需担保"},
                    {keyId: 2, text: "无担保"},
                ];
                let obj=[v1];
                if(this.formData.cBqlb==='2'&&this.formData.cBqlx!=='3'){
                    obj.push(v2);
                }
                if(this.formData.cBqlb==='4'||this.formData.cBqlx==='1'){
                    obj.push(v3);
                }
                return obj;
            },
            RMB: function () {
                let num = Number(this.formData.nSqbqje) === Number(this.formData.nSqbqje) ? Number(this.formData.nSqbqje) : 0
                if (num < 1000) {
                    num = 30
                } else if (num < 100000) {
                    num = 30 + (num - 1000) * 0.01
                } else {
                    num = 1020 + (num - 100000) * 0.005
                }
                return num > 5000 ? 5000.00 : num.toFixed(2)
            },
            columnsBqlx() {
                // 保全类别选择【执行前保全】，那么保全类型只显示【证据保全】和【行为保全】
                if (this.formData.cBqlb === '4') {
                    return this.codeList_301000.filter(item => item.keyId !== '1')
                } else {
                    return this.codeList_301000
                }
            },
            columnsBqlb() {
              // 保全类型选择【财产保全】，那么保全类别只显示【诉前保全】和【诉讼保全】
                if (this.formData.cBqlx ==='1' && this.ahList.length) {
                    return this.codeList_304000.filter(item => (this.powerKeys_cBqlb.indexOf(item.keyId) > -1))
                } else if (!this.ahList.length) {
                    // 当没有关联的诉讼案件案号时，下拉不显示诉讼保全选项
                    return this.codeList_304000.filter(item => item.keyId !== '2');
                } else {
                    return this.codeList_304000
                }
            },
            columnsAjlx() {
                return this.codeList_121000.filter(item => (item.keyId !== '12'))
            },
            codeList_fsqj() {
                /*switch (this.formData.cBqlx) {
                    case '1':
                        return this.codeList_301110
                        break;
                    case '2':
                        return []
                        break;
                    case '3':
                        return []
                        break;
                    case '4':
                        return this.codeList_301160
                        break;
                    default:
                        return []
                }*/
                const data_fsqj={
                    1:this.codeList_301110,
                    2:[],
                    3:this.codeList_301110,
                    4:this.codeList_301160
                }
                const dataList=data_fsqj[this.formData.cBqlb];
                this.formData.cFsqj=dataList&&dataList.length?dataList[0].keyId:'';
                this.formData.cFsqjText=dataList&&dataList.length?dataList[0].text:'';
                return dataList;

            },
            /*timeList() {
                let yearList = []
                let minYear = 2018
                let maxYear = new Date().getFullYear()
                for (let i = minYear; i <= maxYear; i++) {
                    yearList.unshift({
                        text: i,
                        keyId: i
                    })
                }
                console.log('--yearList 000',yearList);
                return yearList
            },*/
            isCanCreate(){
                console.log('isCanCreate====', this.formData.cBqlx)
                return (this.formData.cBqlb!=='4'&&(this.formData.cDbqk===2&&this.formData.cBqlx==='1'));
            }
        },
        beforeRouteLeave(to, from, next) {
            if (to.name == "selectBqCourt" || to.name == "selectAy" || to.name == "selectAyXW") {
                from.meta.keepAlive = true;
            } else {
                from.meta.keepAlive = false;
                // this.$destroy()
            }
            next();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.initPowerKeys()

                if (from.name == 'myGuarantee') {
                    vm.getBqJbxx()
                }
                if (from.name == 'preservationNotice') {
                    window.location.reload();
                }
                if (from.name == 'selectCourt' && to.name == 'createPreservation') {
                    let isRefreshBq = sessionStorage.getItem('isRefreshBq');
                    console.log('isRefreshBq:', isRefreshBq);
                    if (isRefreshBq == '0') {
                        sessionStorage.setItem('isRefreshBq', null);
                        // window.location.reload();
                    } else {
                        sessionStorage.setItem('isRefreshBq', 0);
                    }
                } else if (from.name == 'createPreservation' && to.name == 'selectCourt') {
                    sessionStorage.setItem('isRefreshBq', 0);
                }
            });
        },
        deactivated() { //清除keep-alive的缓存
            // this.$destroy(true)
        }
    }
</script>

<style lang="less" scoped>
        .advice-amount {
            margin-top: 10px;
            margin-bottom: 10px;
            text-align: right;

            > span {
                color: #fe4d67;
                font-size: 14px;
                margin-right: 30/2px;
            }
        }
</style>
